<template lang="pug">
div(
    class="flex flex-wrap"
    :class="[alignmentClasses, spacingClasses]"
)
    template(v-for="button in data.buttons")
        ButtonItem(
            :data="button"
            :mobileIsFullWidth="data.mobileIsFullWidth"
            :tabletIsFullWidth="data.tabletIsFullWidth"
            :desktopIsFullWidth="data.desktopIsFullWidth"
        )
</template>

<script>
import ButtonItem from './buttonItem'
import { generateFlexAlignmentClasses, generateGapClasses } from '~/integrations/storyblok/helpers'

export default {
    name: 'ButtonWidget',
    components: {
        ButtonItem,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        alignmentClasses() {
            return generateFlexAlignmentClasses(
                this.data.mobileAlignment,
                this.data.tabletAlignment,
                this.data.desktopAlignment
            )
        },
        spacingClasses() {
            return generateGapClasses(
                this.data.mobileSpacing,
                this.data.tabletSpacing,
                this.data.desktopSpacing
            )
        },
    },
}
</script>
